// components/CookieConsentBanner.jsx
import React, { useEffect, useState } from "react";

const styles = {
  banner: {
    position: "fixed",
    bottom: "24px",
    left: "50%",
    transform: "translateX(-50%)",
    maxWidth: "650px",
    width: "calc(100% - 2rem)",
    backgroundColor: "#fff",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
    border: "1px solid #dcdcdc",
    padding: "24px",
    borderRadius: "12px",
    zIndex: 9999,
    transition: "all 0.3s ease-in-out",
    fontFamily: "'Open Sans', sans-serif",
    fontSize: "16px",
    color: "#1e1e1e"
  },
  paragraph: {
    marginBottom: "12px",
    lineHeight: "1.5"
  },
  details: {
    fontSize: "14px",
    color: "#4b4b4b",
    marginTop: "10px"
  },
  link: {
    color: "#007c89",
    textDecoration: "underline"
  },
  toggleButton: {
    color: "#007c89",
    fontSize: "14px",
    marginTop: "8px",
    background: "none",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    padding: 0
  },
  buttonGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "20px"
  },
  button: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "8px",
    border: "1px solid transparent",
    cursor: "pointer",
    fontWeight: "600",
    transition: "all 0.2s ease-in-out",
  },
  rejectButton: {
    backgroundColor: "#f3f3f3",
    color: "#333",
    border: "1px solid #ccc"
  },
  acceptButton: {
    backgroundColor: "#007c89",
    color: "#fff",
    border: "1px solid #007c89"
  }
};

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleConsent = (accepted) => {
    localStorage.setItem("cookie-consent", accepted ? "accepted" : "rejected");

    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: accepted ? "granted" : "denied",
        analytics_storage: accepted ? "granted" : "denied",
      });
    }

    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.banner}>
      <div>
        <p style={styles.paragraph}>
          We use cookies to ensure you get the best experience on our website. By continuing to browse, you agree to our use of cookies.
        </p>
        {expanded && (
          <div style={styles.details}>
            We use essential and analytical cookies to improve our services.
          </div>
        )}
        <button
          onClick={() => setExpanded(!expanded)}
          style={styles.toggleButton}
        >
          {expanded ? "Hide details" : "Show details"}
        </button>
      </div>
      <div style={styles.buttonGroup}>
        <button
          onClick={() => handleConsent(false)}
          style={{ ...styles.button, ...styles.rejectButton }}
        >
          Reject
        </button>
        <button
          onClick={() => handleConsent(true)}
          style={{ ...styles.button, ...styles.acceptButton }}
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;